import React from 'react';

// constants
import {
  NOTIFICATION_MODULE_MENU_LABEL,
  NOTIFICATION_PREVIEW_TYPES,
} from '../../../../../../constraints';
import { useTenantList } from '../../../../../Tenants/hooks/useTenantList';

// components
import { NotificationSection, GroupHeaderManageButton } from './components';
import { Grid, Utils } from 'billon-ui';
const { Row } = Grid;
const { Loader: LoaderModule } = Utils;
const { Loader } = LoaderModule;

const PublicGroupContent = ({ templateData }) => {
  const { data: tenants, isLoading: areTenantsLoading } = useTenantList();

  if (areTenantsLoading) {
    return <Loader width={100} />;
  }

  return (
    <>
      <Row>
        <GroupHeaderManageButton
          titleMessageId={NOTIFICATION_MODULE_MENU_LABEL.CONTENTS_CONFIGURATION}
        />
      </Row>
      <Row md={12}>
        <NotificationSection
          id={templateData?.id}
          titleMessageId={NOTIFICATION_MODULE_MENU_LABEL.EMAIL}
          template={templateData?.emailTemplate}
          publicDocumentType={templateData?.publicDocumentType}
          templateTitle={templateData?.emailTitle}
          tenants={tenants}
          previewType={NOTIFICATION_PREVIEW_TYPES.EMAIL}
          isMinusMarginTop={true}
        />
      </Row>
      <br />
      <Row md={12}>
        <NotificationSection
          id={templateData?.id}
          titleMessageId={NOTIFICATION_MODULE_MENU_LABEL.SMS}
          template={templateData?.smsTemplate}
          tenants={tenants}
          previewType={NOTIFICATION_PREVIEW_TYPES.SMS}
        />
      </Row>
    </>
  );
};

export default PublicGroupContent;
